import React, { useEffect, useRef } from 'react'
import { FaSpinner } from 'react-icons/fa'
import { useParams, useNavigate } from 'react-router-dom'
import useOpportunitiesActions from '../../hooks/useOpportunitiesActions'
import { toastSuccess } from '../../../helper'
import { useSourceContext } from '../../context/source/SourceProvider'

export default function FormUpdateCountryOpportunitySource() {
  const { country_id } = useParams()
  const navigate = useNavigate()
  const { getCountryOpportunitySource, updateCountryOpportunitySource, inProgress } = useOpportunitiesActions()
  const { sourceState } = useSourceContext()

  const sourceArRef = useRef(null)
  const sourceEnRef = useRef(null)
  const sourceLinkRef = useRef(null)

  useEffect(() => {
    getCountryOpportunitySource(country_id)
  }, [country_id])

  async function handleOnSubmitSourceForm(e) {
    e.preventDefault()

    const payload = {
      source_ar: sourceArRef.current.value,
      source_en: sourceEnRef.current.value,
      link: sourceLinkRef.current.value,
    }

    const message = await updateCountryOpportunitySource(country_id, payload)

    if (message) {
      toastSuccess(message)
      navigate(`/countries/opportunities`)
    }
  }

  const source = sourceState?.source
  return (
    <form
      onSubmit={handleOnSubmitSourceForm}
      className="flex flex-col gap-4"
    >
      <div className="flex gap-4">
        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTUNITY_SOURCE_AR"
          >
            المصدر بالعربية <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_OPPORTUNITY_SOURCE_AR"
            ref={sourceArRef}
            type="text"
            defaultValue={source?.source_ar}
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
            required
          />
        </div>
        <div className="flex flex-col w-full gap-1">
          <label
            className="font-bold"
            htmlFor="ID_OPPORTUNITY_SOURCE_EN"
          >
            المصدر بالإنجليزية <span className="text-danger-600">*</span>
          </label>
          <input
            id="ID_OPPORTUNITY_SOURCE_EN"
            ref={sourceEnRef}
            type="text"
            defaultValue={source?.source_en}
            className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
            required
          />
        </div>
      </div>
      <div className="flex flex-col w-full gap-1">
        <label
          className="font-bold"
          htmlFor="ID_OPPORTUNITY_SOURCE_LINK"
        >
          رابط المصدر <span className="text-danger-600">*</span>
        </label>
        <input
          dir="ltr"
          id="ID_OPPORTUNITY_SOURCE_LINK"
          ref={sourceLinkRef}
          type="url"
          defaultValue={source?.link}
          placeholder="https://..."
          className="px-4 py-2 leading-none border-2 outline-none border-muted-500"
          required
        />
      </div>
      <button
        type="submit"
        disabled={inProgress}
        className="flex items-center justify-center w-full gap-2 px-6 py-3 font-bold text-white border-2 outline-none border-primary-600 bg-primary-600 hover:border-accent-600 hover:bg-accent-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
      >
        {inProgress ? (
          <>
            <FaSpinner size={16} className="animate-spin" />
            <span>جاري التعديل...</span>
          </>
        ) : (
          <span>تحديث المصدر</span>
        )}
      </button>
    </form>
  )
}
